export default __webpack_public_path__ + "static/media/people.45d274ee.svg";